export interface coordSystemsInterface {
  [key: string]: string;
}

export const coordSystems: coordSystemsInterface = {
  "2056": "CH1903+ / LV95",
  "21781": "CH1903 / LV03",
  "25828": "ETRS89 / UTM zone 28N",
  "25829": "ETRS89 / UTM zone 29N",
  "25830": "ETRS89 / UTM zone 30N",
  "25831": "ETRS89 / UTM zone 31N",
  "25832": "ETRS89 / UTM zone 32N",
  "25833": "ETRS89 / UTM zone 33N",
  "25834": "ETRS89 / UTM zone 34N",
  "25835": "ETRS89 / UTM zone 35N",
  "25836": "ETRS89 / UTM zone 36N",
  "25837": "ETRS89 / UTM zone 37N",
  "25838": "ETRS89 / UTM zone 38N",
  "26901": "NAD83 / UTM zone 1N",
  "26902": "NAD83 / UTM zone 2N",
  "26903": "NAD83 / UTM zone 3N",
  "26904": "NAD83 / UTM zone 4N",
  "26905": "NAD83 / UTM zone 5N",
  "26906": "NAD83 / UTM zone 6N",
  "26907": "NAD83 / UTM zone 7N",
  "26908": "NAD83 / UTM zone 8N",
  "26909": "NAD83 / UTM zone 9N",
  "26910": "NAD83 / UTM zone 10N",
  "26911": "NAD83 / UTM zone 11N",
  "26912": "NAD83 / UTM zone 12N",
  "26913": "NAD83 / UTM zone 13N",
  "26914": "NAD83 / UTM zone 14N",
  "26915": "NAD83 / UTM zone 15N",
  "26916": "NAD83 / UTM zone 16N",
  "26917": "NAD83 / UTM zone 17N",
  "26918": "NAD83 / UTM zone 18N",
  "26919": "NAD83 / UTM zone 19N",
  "26920": "NAD83 / UTM zone 20N",
  "26921": "NAD83 / UTM zone 21N",
  "26922": "NAD83 / UTM zone 22N",
  "26923": "NAD83 / UTM zone 23N",
  "3006": "SWEREF99 TM",
  "3007": "SWEREF99 12 00",
  "3008": "SWEREF99 13 30",
  "3009": "SWEREF99 15 00",
  "3010": "SWEREF99 16 30",
  "3011": "SWEREF99 18 00",
  "3012": "SWEREF99 14 15",
  "3013": "SWEREF99 15 45",
  "3014": "SWEREF99 17 15",
  "3015": "SWEREF99 18 45",
  "3016": "SWEREF99 20 15",
  "3017": "SWEREF99 21 45",
  "3018": "SWEREF99 23 15",
  "31254": "MGI / Austria GK West",
  "31255": "MGI / Austria GK Central",
  "31256": "MGI / Austria GK East",
  "31257": "MGI / Austria GK M28",
  "31258": "MGI / Austria GK M31",
  "31259": "MGI / Austria GK M34",
  "31466": "DHDN90 / 3-degree Gauss-Kruger zone 2",
  "31467": "DHDN90 / 3-degree Gauss-Kruger zone 3",
  "31468": "DHDN90 / 3-degree Gauss-Kruger zone 4",
  "31469": "DHDN90 / 3-degree Gauss-Kruger zone 5",
  "31700": "Dealul Piscului 1970 / Stereo 70",
  "32601": "WGS 84 / UTM zone 1N",
  "32602": "WGS 84 / UTM zone 2N",
  "32603": "WGS 84 / UTM zone 3N",
  "32604": "WGS 84 / UTM zone 4N",
  "32605": "WGS 84 / UTM zone 5N",
  "32606": "WGS 84 / UTM zone 6N",
  "32607": "WGS 84 / UTM zone 7N",
  "32608": "WGS 84 / UTM zone 8N",
  "32609": "WGS 84 / UTM zone 9N",
  "32610": "WGS 84 / UTM zone 10N",
  "32611": "WGS 84 / UTM zone 11N",
  "32612": "WGS 84 / UTM zone 12N",
  "32613": "WGS 84 / UTM zone 13N",
  "32614": "WGS 84 / UTM zone 14N",
  "32615": "WGS 84 / UTM zone 15N",
  "32616": "WGS 84 / UTM zone 16N",
  "32617": "WGS 84 / UTM zone 17N",
  "32618": "WGS 84 / UTM zone 18N",
  "32619": "WGS 84 / UTM zone 19N",
  "32620": "WGS 84 / UTM zone 20N",
  "32621": "WGS 84 / UTM zone 21N",
  "32622": "WGS 84 / UTM zone 22N",
  "32623": "WGS 84 / UTM zone 23N",
  "32624": "WGS 84 / UTM zone 24N",
  "32625": "WGS 84 / UTM zone 25N",
  "32626": "WGS 84 / UTM zone 26N",
  "32627": "WGS 84 / UTM zone 27N",
  "32628": "WGS 84 / UTM zone 28N",
  "32629": "WGS 84 / UTM zone 29N",
  "32630": "WGS 84 / UTM zone 30N",
  "32631": "WGS 84 / UTM zone 31N",
  "32632": "WGS 84 / UTM zone 32N",
  "32633": "WGS 84 / UTM zone 33N",
  "32634": "WGS 84 / UTM zone 34N",
  "32635": "WGS 84 / UTM zone 35N",
  "32636": "WGS 84 / UTM zone 36N",
  "32637": "WGS 84 / UTM zone 37N",
  "32638": "WGS 84 / UTM zone 38N",
  "32639": "WGS 84 / UTM zone 39N",
  "32640": "WGS 84 / UTM zone 40N",
  "32641": "WGS 84 / UTM zone 41N",
  "32642": "WGS 84 / UTM zone 42N",
  "32643": "WGS 84 / UTM zone 43N",
  "32644": "WGS 84 / UTM zone 44N",
  "32645": "WGS 84 / UTM zone 45N",
  "32646": "WGS 84 / UTM zone 46N",
  "32647": "WGS 84 / UTM zone 47N",
  "32648": "WGS 84 / UTM zone 48N",
  "32649": "WGS 84 / UTM zone 49N",
  "32650": "WGS 84 / UTM zone 50N",
  "32651": "WGS 84 / UTM zone 51N",
  "32652": "WGS 84 / UTM zone 52N",
  "32653": "WGS 84 / UTM zone 53N",
  "32654": "WGS 84 / UTM zone 54N",
  "32655": "WGS 84 / UTM zone 55N",
  "32656": "WGS 84 / UTM zone 56N",
  "32657": "WGS 84 / UTM zone 57N",
  "32658": "WGS 84 / UTM zone 58N",
  "32659": "WGS 84 / UTM zone 59N",
  "32660": "WGS 84 / UTM zone 60N",
  "3765": "HTRS96 / Croatia TM",
  "3873": "ETRS89 / GK19FIN",
  "3874": "ETRS89 / GK20FIN",
  "3875": "ETRS89 / GK21FIN",
  "3876": "ETRS89 / GK22FIN",
  "3877": "ETRS89 / GK23FIN",
  "3878": "ETRS89 / GK24FIN",
  "3879": "ETRS89 / GK25FIN",
  "3880": "ETRS89 / GK26FIN",
  "3881": "ETRS89 / GK27FIN",
  "3882": "ETRS89 / GK28FIN",
  "3883": "ETRS89 / GK29FIN",
  "3884": "ETRS89 / GK30FIN",
  "3885": "ETRS89 / GK31FIN",
  "4326": "WGS84",
  "0": "Ellipsoidal",
  "105778": "Wiener Null",
  "12345": "MN75",
  "3900": "N2000",
  "5214": "Genoa",
  "5610": "HVRS71",
  "5613": "RH2000",
  "5717": "N60",
  "5728": "LN02",
  "5729": "LHN95",
  "5778": "GHA",
  "5783": "DHHN92",
  "5941": "NN2000",
  "7837": "DHHN2016",
};
